import { propOr } from 'ramda'
import { createSelector } from 'reselect'

export const selectSettings = state => state.settings

export const selectSettingsList = createSelector(
  selectSettings,
  propOr([], 'list')
)
